import { formatDate } from 'helpers/formatDate';

export const scrollDate = (date, direction) => {
  const newDate = new Date(date);
  newDate.setDate(newDate.getDate() + direction);

  return formatDate(newDate);
};
